import { extendTheme } from "@highoutput/ui-components";
import colors from "./colors";
import components from "./components";
import config from "./config";
import fonts from "./fonts";
import styles from "./styles";

const theme = extendTheme({
  fonts,
  config,
  styles,
  colors,
  components,
});

export default theme;
